import React from 'react';
import dayjs from 'dayjs';

import { formatCurrency } from '../../../utils/helpers';
import {
	ChequeInfoCobrar,
	DepositoInfo,
	OtroInfo,
	TarjetaInfo,
	TransferenciaInfo,
} from '../../Consultas/utils';
import { METODOS_PAGO } from '../../../utils/types';
import PrefixedInput from '../../general/PrefixedInput';

// Primera página del pago académico: fecha, forma de pago, los campos del
// método elegido, el monto recibido y los recuadros de Total/Devuelta. Los tres
// formularios que la usan (cocurriculares, facturación académica y el pago del
// estudiante) sólo difieren en los detalles que aquí son props; sus páginas de
// confirmación, que sí son distintas, siguen en cada archivo.
const CamposPago = ({
	pagoInfo,
	setPagoInfo,
	total,
	fecha = pagoInfo.fecha,
	labelTipoPago = 'Tipo de pago',
	// Sólo cocurriculares ofrece la opción vacía; en los otros dos el select
	// arranca en la primera forma de pago.
	conPlaceholder = false,
	conTarjetaDebito = false,
	// Facturación académica manda el tipo de pago además fuera de `pago_info`.
	hiddenTipoPagoPlano = false,
	// Cocurriculares usa la versión controlada que vive en Ingresos.
	ChequeInfo = ChequeInfoCobrar,
	// El pago del estudiante no envía este monto: viaja en un hidden propio.
	montoName,
}) => (
	<>
		<div className="form-group">
			<label>Fecha</label>
			<input
				type="date"
				className="form-control"
				id="fecha"
				name="pago_info[fecha]"
				onChange={(e) => {
					const { value } = e.target;

					setPagoInfo((state) => ({
						...state,
						fecha: value,
					}));
				}}
				min={dayjs().format("YYYY-MM-DD")}
				value={fecha}
			/>
		</div>

		<div className="form-group">
			<label>{labelTipoPago}</label>
			<select
				className="form-control"
				name="pago_info[tipo_pago]"
				value={pagoInfo.tipo_pago}
				onChange={(e) => {
					e.persist();
					setPagoInfo((state) => ({
						...state,
						tipo_pago: e.target.value,
					}));
				}}
			>
				{conPlaceholder && <option value="">-- Seleccionar --</option>}
				{METODOS_PAGO.map((metodo) => (
					<option key={metodo.value} value={metodo.value}>
						{metodo.label}
					</option>
				))}
			</select>
			<input
				type="hidden"
				name="pago_info[metodo_pago][tipo_pago]"
				value={pagoInfo.tipo_pago}
			/>
			{hiddenTipoPagoPlano && (
				<input
					type="hidden"
					name="metodo_pago[tipo_pago]"
					value={pagoInfo.tipo_pago}
				/>
			)}
		</div>

		{pagoInfo.tipo_pago === "cheque" && <ChequeInfo />}
		{pagoInfo.tipo_pago === "tarjeta" && <TarjetaInfo />}
		{conTarjetaDebito && pagoInfo.tipo_pago === "tarjeta-debito" && <TarjetaInfo />}
		{pagoInfo.tipo_pago === "transferencia" && (<TransferenciaInfo /> )}
		{pagoInfo.tipo_pago === "deposito" && <DepositoInfo />}
		{pagoInfo.tipo_pago === "otro" && <OtroInfo />}

		<div className="form-group">
			<label>Monto Recibido</label>
			<PrefixedInput
				type="number"
				prefix="RD$"
				name={montoName}
				value={pagoInfo.pago}
				setValue={(e) =>
					setPagoInfo((state) => ({
						...state,
						pago: e,
					}))
				}
			/>
		</div>
		<div
			className="row"
			style={{ justifyContent: "space-around" }}
		>
			<div
				className="col-5 text-center"
				style={{
					border: "1px solid #cdd2d7",
					borderRadius: "7px",
					paddingTop: "8px",
					paddingBottom: "8px",
					cursor: "pointer",
				}}
				onClick={() => setPagoInfo(prev => ({...prev, pago: total}))}
			>
				<h5 className="mb-2">Total a Pagar:</h5>
				<p>
					{formatCurrency(total)}
				</p>
			</div>
			<div
				className="col-5 text-center"
				style={{
					border: "1px solid #cdd2d7",
					borderRadius: "7px",
					paddingTop: "8px",
					paddingBottom: "8px",
				}}
			>
				<h5 className="mb-2">Devuelta:</h5>
				<p>
				{pagoInfo.pago > total
					? formatCurrency(
						pagoInfo.pago - total
					)
					: 0}
				</p>
			</div>
		</div>
	</>
);

export default CamposPago;
